import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import LabelWrapper from "components/Common/LabelWrapper";
import { useFormik } from "formik";
import { LINK_FOR_NO_IMAGE } from "helpers/constans";
import { customToFixed } from "helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getAllToken, getPoolTokenBalance, getQuote, postPool, postSwap } from "store/thunks";
import * as Yup from "yup";
import DialogToken from "./DialogToken";
export interface Props {
    isOpen?: boolean;
    detail?: any | null,
    listToken: any[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const PoolForm = ({
    isOpen = false,
    detail = null,
    listToken = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [isColumnReverse, setIsColumnReverse] = useState<boolean>(false);

    const [isOpenDialogToken, setIsOpenDialogToken] = useState<'a' | 'b' | null>(null);

    const FEE_TIER_OPTIONS = [{ label: '0.0%', value: '0' }, { label: '0.3%', value: '0.003' }, { label: '0.5%', value: '0.005' }, { label: '1.0%', value: '0.01' }, { label: '2.0%', value: '0.02' }, { label: '3.0%', value: '0.03' }, { label: '4.0%', value: '0.04' }, { label: '5.0%', value: '0.05' }];

    const onCloseClick = () => {
        onClose && onClose();
        formik.resetForm();
    };

    function compareStringsAsBytes(strA: string, strB: string) {
        const aBytes = Array.from(strA).map(c => c.charCodeAt(0));
        const bBytes = Array.from(strB).map(c => c.charCodeAt(0));

        const len = Math.min(aBytes.length, bBytes.length);
        for (let i = 0; i < len; i++) {
            if (aBytes[i] > bBytes[i]) return 1;
            if (aBytes[i] < bBytes[i]) return -1;
        }

        if (aBytes.length > bBytes.length) return 1;
        if (aBytes.length < bBytes.length) return -1;

        return 0;
    }

    const handleSubmit = async (values: any) => {
        try {
            // setIsLoading((_prev) => true);

            const type_input = values?.type_input;

            const v_token_a = values?.token_a?.mint;
            const v_token_b = values?.token_b?.mint;

            const is_token_a_compare_token_b = compareStringsAsBytes(v_token_a, v_token_b);

            let tokenMintA = values?.token_a;
            let tokenMintB = values?.token_b;
            if (is_token_a_compare_token_b < 0) {
                tokenMintA = values?.token_b;
                tokenMintB = values?.token_a;
            }

            const inputTokenAmount = type_input === 'a' ? values?.amount_a : values?.amount_b;

            const inputTokenMint = type_input === 'a' ? values?.token_a?.mint : values?.token_b?.mint;

            const data = {
                tokenMintA: tokenMintA?.mint,
                tokenMintB: tokenMintB?.mint,

                tokenDecimalA: Number(tokenMintA?.decimals || 0),
                tokenDecimalB: Number(tokenMintB?.decimals || 0),

                tokenProgramA: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
                tokenProgramB: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",

                initialPrice: Number(values?.initial_price || 0),

                inputTokenAmount: Number(inputTokenAmount || 0), // tuỳ vào vị trí nhập Amount
                inputTokenMint: inputTokenMint,  // tuỳ vào vị trí nhập Amount

                isTokenA: tokenMintA?.mint // mặc định truyền vào token A
            };

            const response: any = await postPool(data);
            if (response?.data) {
                setIsLoading((_prev) => false);
                toast(
                    <div>
                        {t("The process has been completed.")} -
                        <a href={`https://solscan.io/tx/${Array.isArray(response?.data) ? response?.data?.[0] : (response?.data || '')}`} className="text-primary text-decoration-underline" target="_blank" rel="noopener noreferrer">TX</a>
                    </div>,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                onCloseClick();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        token_a: Yup.object().shape({
            name: Yup.string(),
            mint: Yup.string(),
            symbol: Yup.string(),
        }).nullable(),
        token_b: Yup.object().shape({
            name: Yup.string(),
            mint: Yup.string(),
            symbol: Yup.string(),
        }).nullable(),
        amount_a: Yup.number().nullable(),
        address_a: Yup.string().nullable(),
        amount_b: Yup.number().nullable(),
        initial_price: Yup.number().nullable(),
        address_b: Yup.string().nullable(),
        fee_tier: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).nullable(),
        type_input: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            token_a: null,
            token_b: null,
            amount_a: '',
            address_a: '',
            amount_b: '',
            address_b: '',
            type_input: 'a',
            initial_price: 0,
            fee_tier: FEE_TIER_OPTIONS[2],
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const _amount_a = detail?.amount_a || '';
                const _address_a = detail?.address_a || '';
                const _amount_b = detail?.amount_b || '';
                const _address_b = detail?.address_b || '';

                const _slippage = FEE_TIER_OPTIONS[2];

                formik.setFieldValue('amount_a', _amount_a);
                formik.setFieldValue('address_a', _address_a);
                formik.setFieldValue('amount_b', _amount_b);
                formik.setFieldValue('address_b', _address_b);

                formik.setFieldValue('type_input', 'a');
                formik.setFieldValue('slippage', _slippage);
                formik.setFieldValue('initial_price', 0);


                formik.setFieldValue('token_a', listToken?.[0]);
                formik.setFieldValue('token_b', listToken?.[5]);

                setTimeout(() => {
                    formik.setErrors({});
                }, 300);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);


    const handleChangeToken = (_token_change: any) => {
        formik.setFieldValue(`token_${isOpenDialogToken}`, _token_change);
        setIsOpenDialogToken(null);
    };

    const handleSwapToken = () => {
        const token_a = formik?.values?.token_a;
        const token_b = formik?.values?.token_b;
        formik.setFieldValue(`token_a`, token_b);
        formik.setFieldValue(`token_b`, token_a);
        const initial_price = formik?.values?.initial_price || 0;
        if (formik?.values?.type_input === 'a') {
            const amount_a = Number(formik?.values?.amount_a || 0);
            const quote = Number(initial_price);
            const xx = (amount_a * quote);
            formik.setFieldValue("amount_b", customToFixed(Number(xx || 0), (token_b as any)?.decimals));
        } else if (formik?.values?.type_input === 'b') {
            const amount_b = Number(formik?.values?.amount_b || 0);
            const quote = Number(initial_price);
            const xx = quote === 0 ? 0 : (Number(amount_b) / quote);
            formik.setFieldValue("amount_a", customToFixed(Number(xx || 0), (token_a as any)?.decimals));
        }
    };

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const [res1]: any = await Promise.all([getQuote({ pair: '' })]);
                formik.setFieldValue('initial_price', Number(res1?.data || 0));
            } catch (error: any) {
                return error;
            }
        };
        // handleCallAllOption();
    }, []);


    const [minPrice, setMinPrice] = useState(0.910743);
    const [maxPrice, setMaxPrice] = useState(1.103510);

    const incrementMin = () => setMinPrice((prev) => parseFloat((prev + 0.01).toFixed(6)));
    const decrementMin = () => setMinPrice((prev) => parseFloat((prev - 0.01).toFixed(6)));
    const incrementMax = () => setMaxPrice((prev) => parseFloat((prev + 0.01).toFixed(6)));
    const decrementMax = () => setMaxPrice((prev) => parseFloat((prev - 0.01).toFixed(6)));

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                // className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1 pb-3 border border-dashed border-end-0 border-start-0 border-top-0">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{t('Create Pool')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12}
                                    md={6}
                                    xl={12}
                                    xxl={12}
                                    className="mt-2 mb-2"
                                >
                                    <div className="d-flex gap-3">
                                        <div style={{ width: '100px' }}>
                                            <LabelWrapper label={t('Fee Tier')} isShow={true}>
                                                <DropdownOption
                                                    name="fee_tier"
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    dataList={FEE_TIER_OPTIONS}
                                                    initialValue={formik?.values?.fee_tier || FEE_TIER_OPTIONS[2]}
                                                    onChangeSelect={(event: any) => {
                                                        formik.setFieldValue('fee_tier', event);
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                    </div>
                                </Col>
                                <div className={`d-flex position-relative gap-2 ${isColumnReverse ? 'flex-column-reverse' : 'flex-column'}`}>
                                    {/* <div className="position-absolute bg-primary-subtle cursor-pointer" style={{
                                        left: '50%',
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        fontSize: '22px',
                                        border: '1px solid var(--vz-primary)',
                                        width: '30px',
                                        height: '30px',
                                        textAlign: 'center',
                                        borderRadius: '4px',
                                        zIndex: '1'
                                    }}
                                        onClick={() => { }}
                                    >
                                        <i className="bx bx-sort-alt-2 text-primary" />
                                    </div> */}
                                    <div
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                        className="bg-primary-subtle"
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_a" className="form-label">{t('Amount')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_a"
                                                        type="text"
                                                        className="form-control fs-18"
                                                        id="amount_a"
                                                        placeholder={'0.0'}
                                                        value={formik?.values?.amount_a}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            const quote = Number(formik?.values?.initial_price || 0);
                                                            formik.setFieldValue("amount_a", s);
                                                            formik.setFieldValue("amount_b", customToFixed(Number(s * quote), (formik?.values?.token_b as any)?.decimals));
                                                            formik.setFieldValue('type_input', 'a');
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            bottom: '5px',
                                                            right: '5px',
                                                            backgroundColor: '#e9e9e9a8',
                                                            padding: '1px 6px',
                                                            borderRadius: '8px',
                                                            minHeight: '33px'
                                                        }}
                                                        className="position-absolute fw-medium text-secondary cursor-pointer"
                                                        onClick={() => setIsOpenDialogToken('a')}
                                                    >
                                                        <div className="d-flex justify-content-end align-items-center gap-1">
                                                            <div className="text-center m-auto w-[24px]">
                                                                <img
                                                                    src={(formik?.values?.token_a as any)?.logo || LINK_FOR_NO_IMAGE}
                                                                    style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                    className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                    alt="token"
                                                                />
                                                            </div>
                                                            <div className="fs-22 mb-0">
                                                                {(formik?.values?.token_a as any)?.symbol}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {formik.touched.amount_a && formik.errors.amount_a ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_a}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    <div
                                        className="bg-primary-subtle"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_b" className="form-label">{t('Amount')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_b"
                                                        type="text"
                                                        className="form-control fs-18"
                                                        id="amount_b"
                                                        placeholder={'0.0'}
                                                        value={formik?.values?.amount_b}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            const quote = Number(formik?.values?.initial_price || 0);
                                                            const xx = quote === 0 ? 0 : (Number(s) / quote);
                                                            formik.setFieldValue("amount_b", s);
                                                            formik.setFieldValue("amount_a", customToFixed(Number(xx || 0), (formik?.values?.token_a as any)?.decimals));
                                                            formik.setFieldValue('type_input', 'b');
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            bottom: '5px',
                                                            right: '5px',
                                                            backgroundColor: '#e9e9e9a8',
                                                            padding: '1px 6px',
                                                            borderRadius: '8px',
                                                            minHeight: '33px'
                                                        }}
                                                        className="position-absolute fw-medium text-secondary cursor-pointer"
                                                        onClick={() => setIsOpenDialogToken('b')}
                                                    >
                                                        <div className="d-flex justify-content-end align-items-center gap-1">
                                                            <div className="text-center m-auto w-[24px]">
                                                                <img
                                                                    src={(formik?.values?.token_b as any)?.logo || LINK_FOR_NO_IMAGE}
                                                                    style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                    className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                    alt="token"
                                                                />
                                                            </div>
                                                            <div className="fs-22 mb-0">
                                                                {(formik?.values?.token_b as any)?.symbol}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {formik.touched.amount_b && formik.errors.amount_b ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_b}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div className="text-center font-thin fs-14 mt-1 mb-2">
                                    50% {(formik?.values?.token_a as any)?.symbol} / 50% {(formik?.values?.token_b as any)?.symbol}
                                </div>

                                <Col sm={12}>
                                    <div className="d-flex justify-content-between">
                                        <label htmlFor="initial_price">
                                            {t('Initial Price')}
                                        </label>
                                        <span className="cursor-pointer fs-16 align-middle" onClick={handleSwapToken} >
                                            <i className="bx bx-transfer-alt fs-20 align-middle" /> {(formik?.values?.token_a as any)?.symbol}
                                        </span>
                                    </div>
                                    <div className="position-relative">
                                        <Input
                                            name="initial_price"
                                            type="text"
                                            className="form-control fs-18"
                                            id="initial_price"
                                            placeholder={'0.0'}
                                            value={formik?.values?.initial_price}
                                            onChange={(event: any) => {
                                                const input = event.target.value;
                                                const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                const s = onlyNumbers;
                                                formik.setFieldValue("initial_price", s);
                                                if (formik?.values?.type_input === 'a') {
                                                    const amount_a = Number(formik?.values?.amount_a || 0);
                                                    const quote = Number(s);
                                                    const xx = (amount_a * quote);
                                                    formik.setFieldValue("amount_b", customToFixed(Number(xx || 0), (formik?.values?.token_b as any)?.decimals));
                                                } else if (formik?.values?.type_input === 'b') {
                                                    const amount_b = Number(formik?.values?.amount_b || 0);
                                                    const quote = Number(s);
                                                    const xx = quote === 0 ? 0 : (Number(amount_b) / quote);
                                                    formik.setFieldValue("amount_a", customToFixed(Number(xx || 0), (formik?.values?.token_a as any)?.decimals));
                                                }
                                            }}
                                        />
                                        <div
                                            style={{
                                                bottom: '3px',
                                                right: '5px',
                                                padding: '1px 6px',
                                                minHeight: '33px'
                                            }}
                                            className="position-absolute text-muted fs-16"
                                        >
                                            {(formik?.values?.token_b as any)?.symbol} <span className="fs-14">per</span> {(formik?.values?.token_a as any)?.symbol}
                                        </div>
                                    </div>
                                </Col>

                                {/* <Col sm={12}>
                                    <div>
                                        <div className="w-100">
                                            <div className="flex justify-between items-center mb-2 mt-3">
                                                <label className="">Liquidity Range</label>
                                            </div>

                                            <div className="flex space-x-2 mb-4">
                                                <button className="flex-1 py-2 px-4 bg-gray-200 rounded-lg text-gray-400 hover:bg-gray-300 transition">
                                                    FULL RANGE
                                                </button>
                                                <button className="flex-1 py-2 px-4 bg-blue-400 rounded-lg text-white hover:bg-blue-500 transition">
                                                    CUSTOM RANGE
                                                </button>
                                            </div>

                                            <div className="flex space-x-4">
                                                <div className="flex-1 bg-gray-300 p-3 rounded-lg">
                                                    <label className="block text-sm text-gray-700">MIN PRICE</label>
                                                    <div className="flex items-center space-x-2">
                                                        <input
                                                            type="text"
                                                            value={minPrice}
                                                            className="w-full bg-transparent text-lg focus:outline-none"
                                                        />
                                                        <div className="flex flex-col space-y-1">
                                                            <button
                                                                onClick={incrementMin}
                                                                className="text-gray-400 hover:text-white bg-gray-500 rounded-lg w-[30px] h-[30px]"
                                                            >
                                                                +
                                                            </button>
                                                            <button
                                                                onClick={decrementMin}
                                                                className="text-gray-400 hover:text-white bg-gray-500 rounded-lg w-[30px] h-[30px]"
                                                            >
                                                                −
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <p className="text-sm text-gray-400">-9%</p>
                                                </div>

                                                <div className="flex-1 bg-gray-300 p-3 rounded-lg">
                                                    <label className="block text-sm text-gray-700">MAX PRICE</label>
                                                    <div className="flex items-center space-x-2">
                                                        <input
                                                            type="text"
                                                            value={maxPrice}
                                                            className="w-full bg-transparent text-lg focus:outline-none"
                                                        />
                                                        <div className="flex flex-col space-y-1">
                                                            <button
                                                                onClick={incrementMax}
                                                                className="text-gray-400 hover:text-white bg-gray-500 rounded-lg w-[30px] h-[30px]"
                                                            >
                                                                +
                                                            </button>
                                                            <button
                                                                onClick={decrementMax}
                                                                className="text-gray-400 hover:text-white bg-gray-500 rounded-lg w-[30px] h-[30px]"
                                                            >
                                                                −
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <p className="text-sm text-gray-400">+10%</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col> */}

                                <Col sm={12} className="mb-2 mt-3" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#009ef7] hover:bg-[#0086d2]"
                                            type="submit"
                                            style={{ width: '150px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Update Pool') : t('Create Pool')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#878a99] hover:bg-[#737582]"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
            <DialogToken isOpen={!!isOpenDialogToken} listToken={listToken || []} onClose={() => setIsOpenDialogToken(null)} changeToken={handleChangeToken} />
        </React.Fragment >
    );
};

export default PoolForm;

